import React, { useEffect } from 'react';
import './App.css';
import DateTime from './components/DateTime';
import Weather from './components/Weather';
import Profile from './components/Profile';
import Spotify from './components/Spotify';
import Projects from './components/Projects';
import Languages from './components/Languages';
import Social from './components/Social';
import Footer from './components/Footer';
import DiscordStatus from './components/DiscordStatus';

function App() {
    const DISCORD_ID = "836647735809146930";

    useEffect(() => {
        const titles = ["Kxysl1k | Backend Dev", "Kxysl1k | Arch User", "Kxysl1k | System Admin", "Kxysl1k | Minecraft Engineer"];
        let index = 0;
        const titleInterval = setInterval(() => {
            document.title = titles[index];
            index = (index + 1) % titles.length;
        }, 3000);

        const updateFavicon = async () => {
            try {
                const res = await fetch(`https://api.lanyard.rest/v1/users/${DISCORD_ID}`);
                const json = await res.json();
                if (json.success && json.data.discord_user.avatar) {
                    const avatarUrl = `https://cdn.discordapp.com/avatars/${json.data.discord_user.id}/${json.data.discord_user.avatar}.png?size=64`;
                    const img = new Image();
                    img.crossOrigin = "Anonymous";
                    img.src = avatarUrl;
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = 64;
                        canvas.height = 64;
                        const ctx = canvas.getContext('2d');
                        ctx.beginPath();
                        ctx.arc(32, 32, 32, 0, Math.PI * 2);
                        ctx.closePath();
                        ctx.clip();
                        ctx.drawImage(img, 0, 0, 64, 64);
                        let link = document.querySelector("link[rel~='icon']");
                        if (!link) {
                            link = document.createElement('link');
                            link.rel = 'icon';
                            document.head.appendChild(link);
                        }
                        link.href = canvas.toDataURL('image/png');
                    };
                }
            } catch (e) { console.error(e); }
        };

        updateFavicon();
        return () => clearInterval(titleInterval);
    }, []);

    return (
        <div className="app">
            <main className="bento-container">
                <div className="left-column">
                    <div className="top-widgets">
                        <DateTime />
                        <Weather />
                    </div>
                    <Profile />
                </div>
                <div className="right-column">
                    <Projects />
                    <Languages />
                    <DiscordStatus />
                    <Spotify />
                    <Social />
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default App;